import { render } from "./DraggableGroup.vue?vue&type=template&id=43eab970&scoped=true"
import script from "./DraggableGroup.vue?vue&type=script&lang=js"
export * from "./DraggableGroup.vue?vue&type=script&lang=js"

import "./DraggableGroup.vue?vue&type=style&index=0&id=43eab970&lang=css"
import "./DraggableGroup.vue?vue&type=style&index=1&id=43eab970&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43eab970"]])

export default __exports__